package io.horion.cv.pages

import androidx.compose.runtime.Composable
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.components.forms.Button
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.components.Footer
import io.horion.cv.components.Topbar
import io.horion.cv.styles.connectStyle
import io.horion.cv.utils.Colors
import io.horion.cv.utils.Constants.INTER
import io.horion.cv.utils.Constants.UBUNTU
import org.jetbrains.compose.web.attributes.InputType
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.Input
import org.jetbrains.compose.web.dom.Text

@OptIn(DelicateApi::class)
@Page("validation")
@Composable
fun RegisterPassword() {

    val ctx = rememberPageContext()
    val breakpoint = rememberBreakpoint()
    val isMobile = breakpoint <= Breakpoint.MD
    val fieldWidth = if (isMobile) 300.px else 380.px

    var password by remember { mutableStateOf("") }
    var confirmPassword by remember { mutableStateOf("") }
    var showPassword by remember { mutableStateOf(false) }
    var showConfirmPassword by remember { mutableStateOf(false) }

    Column(
        modifier = Modifier.fillMaxWidth(),
        horizontalAlignment = Alignment.CenterHorizontally
    ) {
        Topbar()

        Column(
            modifier = Modifier
                .fillMaxWidth()
                .padding(top =  if (isMobile) 40.px else 100.px, bottom = 70.px),
            horizontalAlignment = Alignment.CenterHorizontally
        ) {
            SpanText(
                text = "Inscription",
                modifier = Modifier
                    .fontSize(if (isMobile) 24.px else 30.px)
                    .color(Colors.black)
                    .fontWeight(FontWeight.Normal)
                    .fontFamily(UBUNTU)
                    .margin(bottom = 30.px)
            )

            Column(
                modifier = Modifier
                    .fillMaxWidth()
                    .gap(20.px),
                horizontalAlignment = Alignment.CenterHorizontally
            ) {
                Column(
                    modifier = Modifier.gap(10.px)
                ) {
                    SpanText(
                        text = "Mot de passe",
                        modifier = Modifier
                            .fontSize(if (isMobile) 15.px else 18.px)
                            .color(Colors.black)
                            .fontWeight(FontWeight.Medium)
                            .fontFamily(INTER)
                    )

                    Box(
                        modifier = Modifier
                            .width(fieldWidth),
                        contentAlignment = Alignment.CenterEnd
                    ) {
                        Input(
                            type = if (showPassword) InputType.Text else InputType.Password,
                            attrs = Modifier
                                .width(fieldWidth)
                                .height(45.px)
                                .borderRadius(5.px)
                                .backgroundColor(Colors.field.copy(alpha = 40))
                                .border(1.px, LineStyle.Solid, Colors.borders)
                                .padding(topBottom = 12.px, leftRight = 12.px)
                                .fontSize(16.px)
                                .fontFamily(INTER)
                                .color(Colors.Black)
                                .toAttrs {
                                    value(password)
                                    onInput { password = it.value }
                                }
                        )
                        Image(
                            src = if (showPassword) "eye-open.svg" else "eye-close.svg",
                            description = "Toggle password visibility",
                            modifier = Modifier
                                .size(25.px)
                                .margin(right = 15.px)
                                .cursor(Cursor.Pointer)
                                .onClick { showPassword = !showPassword }
                        )
                    }
                }

                Column(
                    modifier = Modifier.gap(10.px)
                ) {
                    SpanText(
                        text = "Confirmer le mot de passe",
                        modifier = Modifier
                            .fontSize(if (isMobile) 15.px else 18.px)
                            .color(Colors.black)
                            .fontWeight(FontWeight.Medium)
                            .fontFamily(INTER)
                    )

                    Box(
                        modifier = Modifier
                            .width(fieldWidth),
                        contentAlignment = Alignment.CenterEnd
                    ) {
                        Input(
                            type = if (showConfirmPassword) InputType.Text else InputType.Password,
                            attrs = Modifier
                                .width(fieldWidth)
                                .height(45.px)
                                .borderRadius(5.px)
                                .backgroundColor(Colors.field.copy(alpha = 40))
                                .border(1.px, LineStyle.Solid, Colors.borders)
                                .padding(topBottom = 12.px, leftRight = 12.px)
                                .fontSize(16.px)
                                .fontFamily(INTER)
                                .color(Colors.Black)
                                .toAttrs {
                                    value(confirmPassword)
                                    onInput { confirmPassword = it.value }
                                }
                        )
                        Image(
                            src = if (showConfirmPassword) "eye-open.svg" else "eye-close.svg",
                            description = "Toggle password visibility",
                            modifier = Modifier
                                .size(25.px)
                                .margin(right = 15.px)
                                .cursor(Cursor.Pointer)
                                .onClick { showConfirmPassword = !showConfirmPassword }
                        )
                    }
                }
                Button(
                    onClick = { ctx.router.navigateTo("confirmation") },
                    modifier = connectStyle.toModifier()
                        .height(42.px)
                        .borderRadius(20.px)
                        .padding(topBottom = 10.px, leftRight = 20.px)
                        .fontSize(18.px)
                        .color(Colors.White)
                        .fontFamily(INTER)
                        .fontWeight(FontWeight.Normal)
                        .margin(top = 40.px)
                        .align(Alignment.CenterHorizontally)
                ) {
                    Text("Suivant")
                }
            }
        }

        Footer()
    }
}